/**
 * Handicrafts and Souvenirs Components
 * Centralized exports for handicrafts and souvenirs components
 */

export { HandicraftsAndSouvenirsSection } from './HandicraftsAndSouvenirsSection';
export { HandicraftList } from './HandicraftList';
export { HandicraftItem } from './HandicraftItem';
export type {
  HandicraftSouvenir,
  HandicraftsAndSouvenirsSectionProps,
} from './types';
